import { Controller } from "stimulus"

export default class extends Controller {
    static targets = []
    static values = {
        id: String
    }

    confirmCancel(event) {
        if (confirm("この予約をキャンセルします（名簿予約との紐付けを取り消します）。よろしいですか？")) {
            this.cancelReservation();
        }
    }

    cancelReservation() {
        const url = `/admin/peraichi_csv_details/${this.idValue}/cancel`;

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // 成功時の処理
                    window.location.reload(); // ページをリロード
                } else {
                    alert(data.message || "キャンセル処理に失敗しました");
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert("エラーが発生しました。");
            });
    }
}